import React from "react";
import "./_static/MainWindow.css";

function MainWindow(props) {
    return (
        <div className="main-window no-print">
            {props.children}
        </div>
    )
}

export default MainWindow
